import GridyCommon from '@/modules/gridy_common';
import I18n from '@/modules/i18n';
import ModuleLoader from '@/modules/module_loader';
import Templates from '@/pages/site/templates';

import GridyIndex from '@/controllers/common/gridy_index_controller';

export default class extends GridyIndex {
  connect() {
    this.grid = $(this.element).find('[data-gridy]');
    this.options = ModuleLoader.getOptions();

    GridyCommon.gridy(this.grid, { url: this.options.gridy.url, ...this.gridyOptions() });
  }

  gridyOptions() {
    return {
      headers: [
        { name: I18n.t('total'), value: 'total_cents' },
        { name: I18n.t('activerecord.models.message.one'), value: 'message' },
        { name: I18n.t('name'), value: 'users.name' },
        { name: I18n.t('activerecord.models.email.one'), value: 'users.email' },
        { name: I18n.t('action.other'), value: '' },
      ],

      sortName: 'charge_attempts.created_at',
      sortOrder: 'desc',
      template: Templates.charge_attempts.gridy,
    };
  }
}
